<template>
  <header class="py-8">
    <div id="user-header" class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="lg:flex lg:items-center lg:justify-between">
        <div class="flex-1 min-w-0">
          <h2
            class="text-2xl font-bold leading-7 text-white sm:text-3xl sm:leading-9 sm:truncate"
          >
            {{ newProjectName }}
          </h2>
        </div>

        <div class="mt-5 flex lg:mt-0 lg:ml-4">
          <span class="shadow-sm rounded-md">
            <button
              type="button"
              @click="$emit('back')"
              class="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-gray-700 hover:bg-gray-600 focus:outline-none focus:shadow-outline-gray focus:border-gray-800 transition duration-150 ease-in-out"
            >
              Cancelar
            </button>
          </span>
        </div>
      </div>

      <form class="hidden" ref="deleteUserForm" action="/" method="POST"></form>
    </div>
  </header>
</template>

<script>
export default {
  props: {
    newProjectName: { type: String, default: 'Nuevo proyecto' },
  },
};
</script>
